import { render, staticRenderFns } from "./BookingConfirmationDialog.vue?vue&type=template&id=ca0dd3ea"
import script from "./BookingConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./BookingConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports